import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,{ref:"appRoot",style:({ transform: 'scale('+_vm.appScale+')'})},[_c(VMain,{attrs:{"fluid":""}},[_c('div',{staticClass:"mainContainer"},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }